import React, { useState, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button, Card, Alert } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";

export default function GastosRegistroPage() {
    const { t } = useContext(TranslatorContext);
    
    const [formData, setFormData] = useState({
        anio_presupuesto: new Date().getFullYear(),
        tipo_gasto: '',
        categoria: '',
        subcategoria: '',
        descripcion: '',
        monto: '',
        fecha_gasto: '',
        fecha_ingreso: new Date().toISOString().split('T')[0],
        responsable: '',
        fondo_asignado: '',
        documento_adjunto: null,
        observaciones: ''
    });

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    // Generar años disponibles
    const generarAniosDisponibles = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= currentYear - 4; i--) {
            years.push(i);
        }
        return years;
    };

    // Categorías principales basadas en la imagen
    const categorias = [
        { value: 'gastos_oficina', label: 'Gastos Oficina', color: '#dc3545' },
        { value: 'edmundo_neira', label: 'Edmundo Neira', color: '#0dcaf0' },
        { value: 'operativa_terreno', label: 'Operativa/Terreno', color: '#198754' },
        { value: 'egresos_operativos', label: 'Egresos Operativos Temporada 24', color: '#ffc107' }
    ];

    // Subcategorías por categoría
    const subcategorias = {
        gastos_oficina: [
            'Arriendo', 'Luz', 'Agua', 'Gasto Común', 'Plan Internet/Teléfono',
            'Sueldo Maxi', 'Sueldo Laura', 'Sueldo Alexa', 'Sueldo Part Time',
            'Sueldo Contador', 'PREVIRED', 'IVA', 'VISA', 'Crédito 2', 'Crédito 3',
            'Zoom', 'Canva', 'Mantención Plan', 'Seguro vehículo'
        ],
        edmundo_neira: [
            'Dividendo', 'Luz', 'Agua', 'Gasto Común', 'Internet', 'Sueldo'
        ],
        operativa_terreno: [
            'Transporte', 'Alimentación', 'Estadía', 'Sueldo'
        ],
        egresos_operativos: [
            'Fondo Resolutivo/Emergencias', 'Sueldo Coordinadores Generales',
            'Sueldo Coordinadores', 'Combustible Temporada'
        ]
    };

    // Fondos disponibles
    const fondos = [
        { value: 'fondo_emergencia', label: 'Fondo Emergencia', presupuesto: 2400000 },
        { value: 'fondo_inversion', label: 'Fondo Inversión', presupuesto: 3000000 },
        { value: 'fondo_capitalizacion', label: 'Fondo Capitalización', presupuesto: 1200000 },
        { value: 'fondo_capacidad_laboral', label: 'Fondo Capacidad Laboral', presupuesto: 3000000 }
    ];

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: files ? files[0] : value
        }));
    };

    const handleCategoriaChange = (e) => {
        setFormData(prev => ({
            ...prev,
            categoria: e.target.value,
            subcategoria: '' // Reset subcategoría cuando cambia la categoría
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validaciones básicas
        if (!formData.tipo_gasto || !formData.categoria || !formData.subcategoria || 
            !formData.monto || !formData.fecha_gasto || !formData.responsable) {
            setAlertMessage('Por favor complete todos los campos obligatorios');
            setShowAlert(true);
            return;
        }

        try {
            // Aquí iría la lógica para enviar los datos al backend
            console.log('Datos del formulario:', formData);
            
            setAlertMessage('Gasto registrado exitosamente');
            setShowAlert(true);
            
            // Reset form
            setFormData({
                anio_presupuesto: new Date().getFullYear(),
                tipo_gasto: '',
                categoria: '',
                subcategoria: '',
                descripcion: '',
                monto: '',
                fecha_gasto: '',
                fecha_ingreso: new Date().toISOString().split('T')[0],
                responsable: '',
                fondo_asignado: '',
                documento_adjunto: null,
                observaciones: ''
            });
        } catch (error) {
            setAlertMessage('Error al registrar el gasto');
            setShowAlert(true);
        }
    };

    const selectedCategoria = categorias.find(cat => cat.value === formData.categoria);
    const subcategoriasDisponibles = formData.categoria ? subcategorias[formData.categoria] || [] : [];

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Registro de Gastos</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='/gastos' className="mc-breadcrumb-link">Gastos</Link></li>
                                <li className="mc-breadcrumb-item">Registro</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <Card className="mc-card">
                        <Card.Header>
                            <h4>Nuevo Gasto</h4>
                        </Card.Header>
                        <Card.Body>
                            {showAlert && (
                                <Alert variant="info" dismissible onClose={() => setShowAlert(false)}>
                                    {alertMessage}
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    {/* Año de presupuesto */}
                                    <Col md={12}>
                                        <Card className="mb-4" style={{ backgroundColor: '#f8f9fa' }}>
                                            <Card.Body className="py-3">
                                                <Row className="align-items-center">
                                                    <Col md={3}>
                                                        <Form.Group className="mb-0">
                                                            <Form.Label className="fw-bold">Año de Presupuesto *</Form.Label>
                                                            <Form.Select
                                                                name="anio_presupuesto"
                                                                value={formData.anio_presupuesto}
                                                                onChange={handleInputChange}
                                                                required
                                                                className="form-select-lg"
                                                            >
                                                                {generarAniosDisponibles().map(year => (
                                                                    <option key={year} value={year}>{year}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={9}>
                                                        <div className="text-muted">
                                                            <strong>Importante:</strong> Este gasto se registrará en el presupuesto del año {formData.anio_presupuesto}. 
                                                            Asegúrese de seleccionar el año correcto antes de continuar.
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    {/* Información Básica */}
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo de Gasto *</Form.Label>
                                            <Form.Select
                                                name="tipo_gasto"
                                                value={formData.tipo_gasto}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Seleccione...</option>
                                                <option value="fijo">Gasto Fijo</option>
                                                <option value="variable">Gasto Variable</option>
                                                <option value="extraordinario">Gasto Extraordinario</option>
                                                <option value="inversion">Inversión</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Categoría *</Form.Label>
                                            <Form.Select
                                                name="categoria"
                                                value={formData.categoria}
                                                onChange={handleCategoriaChange}
                                                required
                                            >
                                                <option value="">Seleccione...</option>
                                                {categorias.map(cat => (
                                                    <option key={cat.value} value={cat.value}>
                                                        {cat.label}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Subcategoría *</Form.Label>
                                            <Form.Select
                                                name="subcategoria"
                                                value={formData.subcategoria}
                                                onChange={handleInputChange}
                                                required
                                                disabled={!formData.categoria}
                                                style={{
                                                    borderLeft: selectedCategoria ? `4px solid ${selectedCategoria.color}` : 'none'
                                                }}
                                            >
                                                <option value="">Seleccione...</option>
                                                {subcategoriasDisponibles.map(subcat => (
                                                    <option key={subcat} value={subcat}>
                                                        {subcat}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Monto ($) *</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="monto"
                                                value={formData.monto}
                                                onChange={handleInputChange}
                                                placeholder="0"
                                                min="0"
                                                step="0.01"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    {/* Fechas */}
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fecha del Gasto *</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="fecha_gasto"
                                                value={formData.fecha_gasto}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fecha de Ingreso</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="fecha_ingreso"
                                                value={formData.fecha_ingreso}
                                                onChange={handleInputChange}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>

                                    {/* Responsable y Fondo */}
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Responsable *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="responsable"
                                                value={formData.responsable}
                                                onChange={handleInputChange}
                                                placeholder="Nombre del responsable"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fondo Asignado</Form.Label>
                                            <Form.Select
                                                name="fondo_asignado"
                                                value={formData.fondo_asignado}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Sin asignar</option>
                                                {fondos.map(fondo => (
                                                    <option key={fondo.value} value={fondo.value}>
                                                        {fondo.label} (${fondo.presupuesto.toLocaleString()})
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    {/* Descripción */}
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descripción</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="descripcion"
                                                value={formData.descripcion}
                                                onChange={handleInputChange}
                                                placeholder="Descripción detallada del gasto..."
                                            />
                                        </Form.Group>
                                    </Col>

                                    {/* Documento adjunto */}
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Documento Adjunto</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="documento_adjunto"
                                                onChange={handleInputChange}
                                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                            />
                                            <Form.Text className="text-muted">
                                                Formatos permitidos: PDF, JPG, PNG, DOC, DOCX
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>

                                    {/* Observaciones */}
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Observaciones</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="observaciones"
                                                value={formData.observaciones}
                                                onChange={handleInputChange}
                                                placeholder="Observaciones adicionales..."
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col md={12} className="text-end">
                                        <Button variant="secondary" className="me-2">
                                            <Link to="/gastos" style={{ color: 'inherit', textDecoration: 'none' }}>
                                                Cancelar
                                            </Link>
                                        </Button>
                                        <Button variant="primary" type="submit">
                                            Registrar Gasto
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}
